import PatientTable from '../components/Dashboard/PatientTable/PatientTable';
import Statistics from '../components/Dashboard/Statistics/Statistics';
import { patients } from '../data/patients';

export default function Dashboard() {
  return (
    <div className="dashboard">
      <Statistics />
      <PatientTable rows={patients} />
    </div >
  );
}

